import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmationDialogComponent } from '../components/confirmation-dialog/confirmation-dialog.component';
import {
  DownloadSavedSnackbarComponent,
  DownloadSavedSnackbarData,
} from '../components/download-saved-snackbar/download-saved-snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class FeedbackService {
  constructor(private snackBar: MatSnackBar, private dialog: MatDialog) { }

  // Function to show a toast message
  showToast(message: string, action = 'OK', duration = 6000) {
    this.snackBar.open(message, action, {
      duration: duration,
      panelClass: ['themed-snackbar']
    });
  }

  // Toast with a tappable action. onAction fires only when the user taps the
  // action button — auto-dismiss does NOT trigger it. The onAction subscription
  // auto-completes when the snackbar closes, so no manual unsubscribe needed.
  showActionToast(
    message: string,
    actionLabel: string,
    onAction: () => void,
    duration = 8000
  ) {
    const ref = this.snackBar.open(message, actionLabel, {
      duration: duration,
      panelClass: ['themed-snackbar']
    });
    ref.onAction().subscribe(() => onAction());
  }

  // Toast with two tappable actions. MatSnackBar's default template only
  // surfaces one action — this routes through a custom component that
  // renders two action buttons plus a dismiss icon.
  showDualActionToast(
    message: string,
    primaryLabel: string,
    primaryAction: () => void,
    secondaryLabel: string,
    secondaryAction: () => void,
    duration = 8000
  ) {
    const data: DownloadSavedSnackbarData = {
      message,
      primaryLabel,
      primaryAction,
      secondaryLabel,
      secondaryAction,
    };
    this.snackBar.openFromComponent(DownloadSavedSnackbarComponent, {
      data,
      duration,
      panelClass: ['themed-snackbar'],
    });
  }

  // Function to show a confirmation dialog
  async showConfirmation(
    title: string = 'Confirm action',
    message: string = 'Are you sure you want to proceed?',
    data?: any[],
    cancelText: string = 'Cancel',
    confirmText: string = 'Confirm',
    needsAiDisclaimer = false,
    cooldownSeconds?: number
  ): Promise<boolean> {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      data: { title, message, data, cancelText, confirmText, needsAiDisclaimer, cooldownSeconds },
      disableClose: true
    });

    return dialogRef.afterClosed().toPromise();
  }
}
